import script from "./membershipFees.vue?vue&type=script&lang=ts&setup=true"
export * from "./membershipFees.vue?vue&type=script&lang=ts&setup=true"

import "./membershipFees.vue?vue&type=style&index=0&id=6acc6296&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6acc6296"]])

export default __exports__